"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_query_1 = require("@tanstack/react-query");
const react_1 = require("react");
const react_router_1 = require("react-router");
const pageSpinner_1 = __importDefault(require("../components/molecules/pageSpinner"));
const errorPage_1 = __importDefault(require("../components/pages/errorPage"));
const appConstants_1 = require("../constants/appConstants");
const teamQuery_1 = require("../queries/teamQuery");
const userQuery_1 = require("../queries/userQuery");
const userSelectors_1 = require("../selectors/userSelectors");
const zustandStore_1 = require("../zustandStore");
const ProtectedRoute = ({ children, allowedRoles }) => {
    const { preventShowErrorPage } = (0, zustandStore_1.useZustand)(state => state.error);
    const initialData = (0, react_router_1.useLoaderData)();
    const { data: teams, isLoading: isGetTeamsLoading } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.teamsQuery)({ state: 'active' }),
        ...(initialData && 'teams' in initialData && { initialData: initialData.teams }),
    });
    const { data: selectedTeamId } = (0, react_query_1.useQuery)({
        ...(0, teamQuery_1.selectedTeamIdQuery)('selectedTeamID'),
        ...(initialData && 'selectedTeamId' in initialData && { initialData: initialData.selectedTeamId }),
    });
    const { data: currentTeam, isLoading: isGetCurrentTeamLoading } = (0, react_query_1.useQuery)((0, teamQuery_1.teamQuery)({ teamId: selectedTeamId?.[0] || teams?.[0]?.id || '' }));
    const { data: currentUser, isLoading: isUserLoading, isFetching: isUserFetching, isSuccess: isUserSuccess, } = (0, react_query_1.useQuery)({
        ...userQuery_1.userQuery,
        initialData: initialData?.userData,
    });
    if (isUserLoading || isGetCurrentTeamLoading || isGetTeamsLoading) {
        return (0, jsx_runtime_1.jsx)(pageSpinner_1.default, { isLoading: true });
    }
    if (allowedRoles?.includes('*')) {
        return children;
    }
    const selectedCurrentTeam = currentTeam?.id || teams?.[0]?.id || '';
    const userRoles = currentUser?.roles || [];
    const userIsSupportAdmin = (0, userSelectors_1.isSupportAdmin)(userRoles || []);
    const userIsCompanyAdmin = (0, userSelectors_1.isCompanyAdmin)(userRoles || []);
    if ((!isUserLoading || !isUserFetching) && isUserSuccess && currentUser && teams) {
        const hasUserRole = userRoles?.some(role => {
            if (userIsCompanyAdmin) {
                return userRoles.length === 1 ? allowedRoles?.includes(role.roleId) : allowedRoles?.includes(appConstants_1.companyAdmin);
            }
            const foundRole = allowedRoles?.find(allowedRole => {
                return allowedRole === role.roleId && role.securityGroupId === selectedCurrentTeam;
            });
            return userIsSupportAdmin || foundRole;
        });
        if (!hasUserRole && !preventShowErrorPage) {
            return (0, jsx_runtime_1.jsx)(errorPage_1.default, {});
        }
        return children;
    }
    return (0, jsx_runtime_1.jsx)(errorPage_1.default, {});
};
exports.default = (0, react_1.memo)(ProtectedRoute);
